/** 몰 단가 계산 — 판매가(+옵션)가 결제 단가다. BE `utils/mallPricing.js` 와 동일. */

export type MallPriceInput = {
  listPrice?: number
  salePrice: number
  optionExtra?: number
  orgDiscountPct?: number
}

export type MallUnitPrice = {
  listUnit: number
  catalogUnit: number
  unitPrice: number
  productOff: number
  orgOff: number
  totalOff: number
  displayDiscountPct: number
  orgDiscountPct: number
}

export function applyOrgDiscount(amount: number): number {
  return Math.max(0, Math.round(Number(amount) || 0))
}

export function calcMallUnitPrice(input: MallPriceInput): MallUnitPrice {
  const salePrice = Math.max(0, Number(input.salePrice) || 0)
  const optionExtra = Math.max(0, Number(input.optionExtra) || 0)

  const listUnit = salePrice + optionExtra
  const catalogUnit = salePrice + optionExtra
  const unitPrice = catalogUnit
  const productOff = 0
  const orgOff = 0
  const totalOff = 0
  const displayDiscountPct = 0
  const orgDiscountPct = 0

  return {
    listUnit,
    catalogUnit,
    unitPrice,
    productOff,
    orgOff,
    totalOff,
    displayDiscountPct,
    orgDiscountPct,
  }
}
